import React from "react";
import "../pages/Proyect.css";
import htmlp from "../Assets/html_p.png";
import cssp from "../Assets/css_p.png";
import reactt from "../Assets/react_p.png";
import learning from "../Assets/list.png";
import BackButton from "../componets/BackButton";



export const LearningList = () => {
      const handleWebButtonClick = () => {
    window.location.href = "https://learning-list-sg.netlify.app/"; // Reemplaza con la URL que quieras
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/learning-list"; // Reemplaza con la URL de tu repositorio en GitHub
  };

  return (
    <div className="proyect-container">
      <BackButton/>
      <div className="proyect-header">
        <h1>Learning List</h1>
     
      <div className="proyect-description">
        <p>
          Web application where the user can create a list of topics to learn,
          can create a topic, mark it as learned, delete it and search by topic
        </p>
      </div>
      <div className="proyect-buttons">
       <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
      <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
        <img src={htmlp} alt="HTML" className="computer" />
        <img src={cssp} alt="CSS" className="computer" />
        <img src={reactt} alt="JavaScript" className="computer" />
      </div> </div>
      <img
        src={learning}
        alt="Learning List"
        className="learning-image"
      />
    </div>
  );
};

